import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './user.state';
import * as Store from '@app/store';

export const selectFeature = createFeatureSelector<State>('userState');

export const selectUser = createSelector(selectFeature, (state) => state.user);

export const selectNotificationPreferences = createSelector(
  selectFeature,
  (state) => state.notificationPreferences,
);

export const selectUserId = createSelector(
  selectUser,
  (user) => user?.WebUserId,
);

export const selectAllHotels = createSelector(
  selectFeature,
  (state) => state.user?.allHotels ?? [],
);
